import BaseError from './base-error'

class MissingDataError extends BaseError {
}

export default MissingDataError
